import configHttp from '../../../../configHttp.js'
var comMapping = {
	$dsrwzt: [{
			label: "停用",
			value: "0"
		},
		{
			label: "已启动",
			value: "1"
		}, {
			label: "正在停用",
			value: "2"
		},
		{
			label: "正在启动",
			value: "3"
		},
		{
			label: "启动失败",
			value: "4"
		},
		{
			label: "停用失败",
			value: "5"
		}
	],
	$sf: [{
			label: "是",
			value: "1"
		},
		{
			label: "否",
			value: "0"
		}
	],
	$scrwlx: [{
			label: "未开始",
			value: "1"
		},
		{
			label: "运行中",
			value: "2"
		},
		{
			label: "执行成功",
			value: "3"
		},
		{
			label: "执行失败",
			value: "4"
		}
	],
	$lx: [{
			label: "资产负债表",
			value: "6"
		},
		{
			label: "明细账报表",
			value: "7"
		},
		{
			label: configHttp.projectType == 'Amat' ? "科目余额" : "科目余额差异分析",//修改为 10  对应 科目余额报表
			value: "10"
		},

		{
			label: "凭证报表",
			value: "13"
		},

		{
			label: "凭证数据",
			value: "15"
		},
		{
			value: '34',
			label: '科目余额变动报表'
		},
		{
			value: '35',
			label: '科目余额变动报表12-15'
		},
		{
			value: '36',
			label: '利润表变动分析报告'
		},
		{
			value: '37',
			label: '利润表变动分析报告_全年'
		},
		{
			value: '38',
			label: '现金流量表变动分析报告'
		},
		{
			value: '39',
			label: '期间费用科目变动分析报告'
		}
	],
	$sczt: [{
			label: "文件导入",
			value: "1"
		},
		{
			label: "接口导入",
			value: "2"
		},
		{
			label: "数据库直连",
			value: "3"
		},
		{
			label: "过账",
			value: "4"
		},
		{
			label: "反过账",
			value: "5"
		},
		{
			label: "资产负债表",
			value: "6"
		},
		{
			label: "明细账报表",
			value: "7"
		},
		{
			label: "日记账报表",
			value: "8"
		},
		{
			label: "总账报表",
			value: "9"
		},
		{
			label: "科目余额报表",
			value: "10"
		},
		{
			label: "科目余额核对报表",
			value: "11"
		},
		{
			label: "费用类报表",
			value: "12"
		},
		{
			label: "凭证报表",
			value: "13"
		},
		{
			label: "定制报表",
			value: "14"
		},
		{
			label: "千户计划 （财年多选）",
			value: "15"
		}
	],
	$kpgb: [{
			label: "开启",
			value: "1"
		},
		{
			label: "关闭",
			value: "0"
		}
	],
	$fzlx: [{
			label: "贷",
			value: "CR"
		},
		{
			label: "借",
			value: "DB"
		}
	],
	$yf: [{
			"value": "01",
			"label": "1月",

		},
		{
			"value": "02",
			"label": "2月",

		},
		{
			"value": "03",
			"label": "3月",

		},
		{
			"value": "04",
			"label": "4月",

		},
		{
			"value": "05",
			"label": "5月",

		},
		{
			"value": "06",
			"label": "6月",

		},
		{
			"value": "07",
			"label": "7月",

		},
		{
			"value": "08",
			"label": "8月",

		},
		{
			"value": "09",
			"label": "9月",

		},
		{
			"value": "10",
			"label": "10月",

		},
		{
			"value": "11",
			"label": "11月",

		},
		{
			"value": "12",
			"label": "12月",

		},
		{
			"value": "13",
			"label": "13期间",

		},
		{
			"value": "14",
			"label": "14期间",

		},
		{
			"value": "15",
			"label": "15期间",

		}
	],
	$bblx: [
		{
			value: '6',
			label: '资产负债表'
		},
		{
			value: '7',
			label: '明细账报表'
		},
		{
			value: '8',
			label: '日记账报表'
		},
		{
			value: '9',
			label: '总账报表'
		},
		{
			value: '10',
			label: '科目余额报表'
		},
		{
			value: '12',
			label: '费用类报表'
		}, 
		{
			value: '13',
			label: '凭证报表'
		},
		{
			value: '14',
			label: '定制报表'
		},
	],
	$amat_bblx: [
		{
			value: '6',
			label: '资产负债表'
		},
		{
			value: '7',
			label: '明细账报表'
		},
		{
			value: '8',
			label: '日记账报表'
		},
		{
			value: '9',
			label: '总账报表'
		},
		{
			value: '10',
			label: '科目余额报表'
		},
		{
			value: '12',
			label: '费用类报表'
		}, 
		{
			value: '13',
			label: '凭证报表'
		},
		{
			value: '34',
			label: '科目余额变动报表'
		},
		{
			value: '35',
			label: '科目余额变动报表12-15'
		},
		{
			value: '36',
			label: '利润表变动分析报告'
		},
		{
			value: '37',
			label: '利润表变动分析报告_全年'
		},
		{
			value: '38',
			label: '现金流量表变动分析报告'
		},
		{
			value: '39',
			label: '期间费用科目变动分析报告'
		}
	]

}
export {
	comMapping
}
